module.exports = __webpack_public_path__ + "img/logoTips.1159e7f3.png";